import jsPDF from "jspdf";
import "jspdf-autotable";

import logo from "../assets/img/logo-orden-pago.png";
import qrContacto from "../assets/img/qr-orden-pago.png";
import redes from "../assets/img/redes-orden-pago.png";
import {
  registrarMontserrat,
  MONTSERRAT,
  MONTSERRAT_LIGHT,
  MONTSERRAT_MEDIUM,
  MONTSERRAT_SEMIBOLD,
} from "./montserratPdfFont";

// Paleta y medidas tomadas del arte definitivo de la orden de pago (A4, pt).
const DARK = [45, 48, 53];
const INK = [35, 35, 35];
const HEAD_PILL = [236, 236, 236];
const TOTAL_PILL = [209, 210, 211];
const ROW_PILL = [244, 244, 244];
const BODY_TEXT = [70, 74, 82];
const FOOTER_TEXT = [198, 198, 198];

const TABLE_LEFT = 13.55;
const TABLE_RIGHT = 581.45;
const TABLE_WIDTH = TABLE_RIGHT - TABLE_LEFT;
// Ancho de cada columna calculado para que los grupos de arriba (DATOS DE LA
// OPERACIÓN, MEDIO DE PAGO, ...) caigan justo sobre sus columnas.
const COL_WIDTHS = [
  33.99, 35.35, 37.67, 36.63, 36.7, 39.57, 37.71, 36.12, 36.18, 36.66, 38.12,
  37.47, 35.61, 41.52, 48.6,
];
const HEAD_PILL_WIDTH = 32.88;
// La de Total op. es más ancha que el resto, casi como la de RESULTADO.
const TOTAL_PILL_WIDTH = 49.98;
const HEAD_PILL_HEIGHT = 7.26;
// Alto y arranque calculados para que la píldora quede en y=240,58 (como el
// arte) y la primera barra de datos caiga 9,38 pt (3,31 mm) más abajo.
const HEAD_ROW_HEIGHT = 15.98;
const BODY_ROW_HEIGHT = 19.8;
const BODY_PILL_HEIGHT = 9.72;
const TABLE_START_Y = 236.22;

// El bloque inferior (Resumen Fiscal + contacto) va anclado al pie de la hoja.
// Con BOTTOM_Y = 620 el pie cierra en y≈778, o sea a ~22mm del borde: queda
// holgado dentro del área imprimible de cualquier impresora. Si la tabla llega
// hasta ahí, el bloque pasa a la hoja siguiente en vez de encimarse.
const BOTTOM_MIN_GAP = 34;
const BOTTOM_Y = 620;

const textValue = (value, fallback = "-") => {
  if (value === null || value === undefined || value === "") return fallback;
  return String(value);
};

const money = (value) => {
  const raw = textValue(value, "0,00").replace(/\$/g, "").trim();
  return `$${raw}`;
};

const setFont = (doc, familia, estilo, size, color) => {
  doc.setFont(familia, estilo);
  doc.setFontSize(size);
  doc.setTextColor(...color);
};

const GRUPOS = [
  [13.55, 102.86, 5.18, "DATOS DE LA OPERACIÓN"],
  [123.85, 66.62, 5.1, "MEDIO DE PAGO"],
  [197.35, 33, 5.1, "VENTA"],
  [236.44, 178.8, 4.33, "COSTOS"],
  [420.25, 106.48, 5.09, "RETENCIONES"],
  [531.7, 49.76, 4.31, "RESULTADO"],
];

const CARDS_X = [13.93, 163.79, 313.61, 460.6];

const drawGroupLabel = (doc, x, width, padding, label) => {
  doc.setFillColor(...DARK);
  doc.roundedRect(x, 214.65, width, 16.42, 2.2, 2.2, "F");
  setFont(doc, MONTSERRAT_SEMIBOLD, "normal", 6.5, [255, 255, 255]);
  doc.text(label, x + padding, 225);
};

const drawCard = (doc, x, amount, label) => {
  doc.setFillColor(...DARK);
  doc.roundedRect(x, 146.81, 121.1, 54.41, 6.1, 6.1, "F");
  setFont(doc, MONTSERRAT, "bold", 13.17, [255, 255, 255]);
  doc.text(money(amount), x + 13.63, 171.52);
  setFont(doc, MONTSERRAT_MEDIUM, "normal", 8.17, [255, 255, 255]);
  doc.text(label, x + 13.63, 185.56);
};

const drawHeader = (doc, info, fechaPago) => {
  doc.addImage(logo, "PNG", 13.4, 18.5, 57.8, 15.4);

  setFont(doc, MONTSERRAT, "normal", 8, [0, 0, 0]);
  ["CUIT: 30 - 71.679.976 - 6", "liquidaciones@zocoweb.com.ar", "www.zocoweb.com.ar"].forEach(
    (linea, index) => doc.text(linea, 13.34, 47.42 + index * 10)
  );

  setFont(doc, MONTSERRAT_SEMIBOLD, "normal", 9, DARK);
  doc.text("Datos del comercio", 219.37, 31.15);
  doc.text("Fecha", 420.18, 31.15);

  const bloque = (x, filas) => {
    filas.forEach(([label, value], index) => {
      const y = 46.57 + index * 11;
      setFont(doc, MONTSERRAT_SEMIBOLD, "normal", 7, DARK);
      doc.text(label, x, y);
      setFont(doc, MONTSERRAT, "normal", 7, DARK);
      doc.text(textValue(value), x + doc.getTextWidth(label) + 2.8, y);
    });
  };

  bloque(219.37, [
    ["Empresa:", info.empresa],
    ["Dirección:", info.direccion],
    ["Provincia:", info.provincia],
    ["Teléfono:", info.telefono],
    ["Email:", info.email],
  ]);
  bloque(420.18, [
    ["Liquidación:", fechaPago],
    ["Banco:", info.banco],
    ["N° CUENTA:", info.nroCuenta],
  ]);
};

const drawSummary = (doc, sumas, base) => {
  setFont(doc, MONTSERRAT_SEMIBOLD, "normal", 6.77, DARK);
  doc.text("RESUMEN FISCAL", 12.89, base);

  setFont(doc, MONTSERRAT_LIGHT, "normal", 7, INK);
  doc.text("Resumen Operaciones", 12.66, base + 14.46);

  const filas = [
    ["Bruto", sumas.bruto],
    ["Arancel", sumas.arancel],
    ["IVA 21%", sumas.ivaArancel],
    ["Cost. transc.", sumas.impDebitoCredito],
    ["Costo Financiero", sumas.costoFinanciero],
    ["Costo Anticipo", sumas.costoPorAnticipo],
    ["Ret. IIBB", sumas.retencionIIBB],
    ["Ret. Ganancias", sumas.retencionGanancia],
    ["Ret. IVA", sumas.retencionIVA],
  ];

  filas.forEach(([label, value], index) => {
    const y = base + 30.39 + index * 13.3;
    setFont(doc, MONTSERRAT_SEMIBOLD, "normal", 7, INK);
    doc.text(label, 12.91, y);
    setFont(doc, MONTSERRAT, "normal", 7, INK);
    doc.text(money(value), 104.8, y);
  });

  doc.setFillColor(...DARK);
  doc.roundedRect(13.52, base + 148.27, 41.46, 9.16, 4.58, 4.58, "F");
  setFont(doc, MONTSERRAT_SEMIBOLD, "normal", 6.44, [255, 255, 255]);
  doc.text("Total op.", 20.22, base + 154.74);
  setFont(doc, MONTSERRAT_SEMIBOLD, "normal", 7, INK);
  doc.text(money(sumas.totalOP), 104.8, base + 154.86);
};

const drawFooter = (doc, base) => {
  const x = 366.25;
  const salto = 7;
  let y = base + 73.36;

  const linea = (partes) => {
    let cursor = x;
    partes.forEach(([texto, fuerte]) => {
      setFont(doc, fuerte ? MONTSERRAT_SEMIBOLD : MONTSERRAT, "normal", 6.5, DARK);
      doc.text(texto, cursor, y);
      cursor += doc.getTextWidth(texto);
    });
    y += salto;
  };

  linea([["Cualquier consulta sobre esta ", false]]);
  linea([["liquidación puede comunicarse con ", false]]);
  linea([["nosotros escaneando el siguiente ", false]]);
  linea([["código y escribirnos de ", false], ["Lunes a ", true]]);
  linea([["Viernes de 08:00 a 17:00 hs.", true]]);

  y += salto;
  linea([["Teléfono: ", true], ["0810-555-4005", false]]);
  linea([["Email: ", true], ["liquidaciones@zocoweb.com.ar", false]]);
  linea([["WhatsApp: ", true], ["+54 9 381 3545650", false]]);

  doc.addImage(qrContacto, "PNG", 510.12, base + 69.53, 70.56, 64.44);
  doc.addImage(redes, "PNG", 459.09, base + 147.73, 46.5, 10.7);

  setFont(doc, MONTSERRAT_MEDIUM, "normal", 6.5, FOOTER_TEXT);
  doc.text("zocoserviciosdepago", 366.01, base + 155.94);
  doc.text("zocoweb.com.ar", 527.24, base + 155.94);
};

const COLUMNS = [
  "Terminal", "N° oper.", "Fecha", "Tarjeta", "Cuotas", "Bruto", "C. fin", "Anticipo",
  "Arancel", "IVA", "Trans.", "IIBB", "Gan.", "IVA", "Total op.",
];

const drawTable = (doc, datos) => {
  const body = datos.length
    ? datos.map((dato) => [
        textValue(dato.terminal), textValue(dato.nroOperacion), textValue(dato.fechaOperacion),
        textValue(dato.tarjeta), textValue(dato.cuotas), money(dato.bruto),
        money(dato.costoFinanciero), money(dato.costoPorAnticipo), money(dato.arancel),
        money(dato.ivaArancel), money(dato.impDebitoCredito), money(dato.retencionIIBB),
        money(dato.retencionGanancia), money(dato.retencionIVA), money(dato.totalOP),
      ])
    : Array.from({ length: 13 }, () => COLUMNS.map(() => ""));

  const columnStyles = {};
  COL_WIDTHS.forEach((cellWidth, index) => {
    columnStyles[index] = { cellWidth };
  });
  // Total op. va en negro y negrita (antes verde), encabezado y valores.
  columnStyles[14] = {
    ...columnStyles[14],
    font: MONTSERRAT,
    fontStyle: "bold",
    textColor: DARK,
  };

  doc.autoTable({
    startY: TABLE_START_Y,
    head: [COLUMNS],
    body,
    theme: "plain",
    // Sin 'avoid' una fila se parte al cambiar de hoja y deja media barra suelta.
    rowPageBreak: "avoid",
    margin: { left: TABLE_LEFT, right: 13.83, bottom: 42 },
    tableWidth: TABLE_WIDTH,
    styles: {
      font: MONTSERRAT,
      fontStyle: "normal",
      fontSize: 5.2,
      textColor: BODY_TEXT,
      cellPadding: { top: 0, bottom: 0, left: 1, right: 1 },
      halign: "center",
      valign: "middle",
      minCellHeight: BODY_ROW_HEIGHT,
      lineWidth: 0,
    },
    headStyles: {
      font: MONTSERRAT_SEMIBOLD,
      fontStyle: "normal",
      fontSize: 5.11,
      textColor: DARK,
      fillColor: false,
      minCellHeight: HEAD_ROW_HEIGHT,
    },
    columnStyles,
    willDrawCell: (data) => {
      const { cell, column, section } = data;
      if (section === "head") {
        const esTotal = column.index === COLUMNS.length - 1;
        const ancho = esTotal ? TOTAL_PILL_WIDTH : Math.min(HEAD_PILL_WIDTH, cell.width - 3);
        doc.setFillColor(...(esTotal ? TOTAL_PILL : HEAD_PILL));
        doc.roundedRect(
          cell.x + (cell.width - ancho) / 2,
          cell.y + (cell.height - HEAD_PILL_HEIGHT) / 2,
          ancho,
          HEAD_PILL_HEIGHT,
          3.63,
          3.63,
          "F"
        );
      } else if (section === "body" && column.index === 0 && cell.height >= BODY_PILL_HEIGHT) {
        doc.setFillColor(...ROW_PILL);
        doc.roundedRect(
          TABLE_LEFT,
          cell.y + (cell.height - BODY_PILL_HEIGHT) / 2,
          TABLE_WIDTH,
          BODY_PILL_HEIGHT,
          3,
          3,
          "F"
        );
      }
    },
  });
};

// Arma el PDF sin guardarlo, para poder previsualizarlo antes de descargar.
export const buildOrdenPagoNuevoDoc = ({ comercioData, tipoData, fechaPago }) => {
  const doc = new jsPDF({ orientation: "portrait", unit: "pt", format: "a4", compress: true });
  registrarMontserrat(doc);

  const info = comercioData?.info || {};
  const acumulados = tipoData?.acumulados || {};
  const datos = tipoData?.datos || [];
  const sumas = tipoData?.sumas || {};

  drawHeader(doc, info, fechaPago);

  setFont(doc, MONTSERRAT_SEMIBOLD, "normal", 10.59, DARK);
  doc.text("Monto acumulado (mes correspondiente)", 12.59, 124.7);
  [
    ["SE ACREDITAN HOY", acumulados.hoySeAcredita],
    ["ACUMULADO", acumulados.acumulado],
    ["DÉBITO", acumulados.acumuladoDebito],
    ["CUOTA", acumulados.acumuladoCredito],
  ].forEach(([label, amount], index) => drawCard(doc, CARDS_X[index], amount, label));

  GRUPOS.forEach(([x, width, padding, label]) => drawGroupLabel(doc, x, width, padding, label));

  drawTable(doc, datos);

  const finalY = doc.lastAutoTable?.finalY ?? TABLE_START_Y;
  let base = BOTTOM_Y;
  if (finalY + BOTTOM_MIN_GAP > base) {
    doc.addPage();
    base = 60;
  }

  drawSummary(doc, sumas, base);
  drawFooter(doc, base);
  return doc;
};

export const renderOrdenPagoNuevo = ({ comercioData, tipoData, fechaPago, filename }) => {
  buildOrdenPagoNuevoDoc({ comercioData, tipoData, fechaPago }).save(filename);
};
